import { Attributes, Misc, ModelBase, NeoModel } from "@singularsystems/neo-core";
import SFTPBrokerDetailsLookup from "../Lookups/SFTPBrokerDetailsLookup";
import { TradeDistributionTypeEnum } from "../Enums/TradeDistributionTypeEnum";

@NeoModel
export default class SaveServiceProviderFileGroupingCommand extends ModelBase {

    public staticServiceProviderFileGroupingId: number = 0;

    public staticServiceProviderId: number = 0;

    public serviceProviderName: string = "";

    public serviceProviderCode: string = "";

    public serviceProviderSubAccountName: string = "";

    public serverName: string = "";

    public serviceProviderGroupingName: string = "";

    public groupingDescription: string = "";

    public databaseName: string = "";

    public isOnshoreInd: boolean = false;

    public ignoreGroupingInd: boolean = false;

    public isActiveInd: boolean = false;

    public importsPublicHolidaysInd: boolean = false;

    public ignoresExchangeRatesInd: boolean = false;

    public clientAltSearchInd: boolean = false;

    public sortOrder: string = "";

    public provideDividendGrossInd: boolean = false;

    public useAccountCurrencyInd: boolean = false;

    public exportsWhenReady: boolean = false;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public exportTime: Date | null = null;

    public isWacEnabled: boolean = false;

    public eventIdFieldName: string = "";

    public exportTimeString: string | null = null;

    public daysOfWeek: string[] = [];

    public tradeDistributionTypeId: TradeDistributionTypeEnum | null = null;

    public sftpBrokerDetailsLookups: SFTPBrokerDetailsLookup[] = [];

    public samReporting: number | null = null;

    public isBroker: boolean = true;

    public isBookCostRunning: boolean = false;
}